<template>
  <Wrapper>
    <IdentFlow />
  </Wrapper>
</template>

<script setup lang="ts">
import IdentFlow from '@/components/ident/IdentFlow.vue'
import Wrapper from '@/components/wrappers/Wrapper.vue'

definePage({
  path: '/flow/:stepId',
  name: 'flow',
  meta: {
    titleKey: 'tab.default',
  },
})
</script>
